import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import CodeableContext from 'contexts/CodeableContext';
import useSelectedExcerpt from './useSelectedExcerpt';
import useResolvedUserId from 'codeable/useResolvedUserId';
import { useDeselectOnRouteChange } from 'hooks/codeable/useDeselectOnRouteChange';

const CodeableContextProvider = ({children, projectId, includeAllUsers}) => {
  const location = useLocation();
  const {
    excerptId: selectedExcerptId,
    select,
    onNewExcerptId,
    onDeselect,
    onSelectText,
    selectedExcerptVisible,
    setSelectedExcerptVisible,
  } = useSelectedExcerpt(null);

  const codingUserId = useResolvedUserId(location, includeAllUsers);

  // A selection doesn't survive a page change — see the hook for the
  // deep-link exception.
  useDeselectOnRouteChange(onDeselect);

  const contextValue = useMemo(() => ({
    selectedExcerptId,
    select,
    onNewExcerptId,
    onDeselect,
    onSelectText,
    selectedExcerptVisible,
    setSelectedExcerptVisible,
    codingUserId
  }), [selectedExcerptId, select, onNewExcerptId, onDeselect, onSelectText, selectedExcerptVisible, setSelectedExcerptVisible, codingUserId]);
  
  return (
    <CodeableContext.Provider value={contextValue}>
      {children}
    </CodeableContext.Provider>
  );
};

export default CodeableContextProvider;
